import React from 'react'
import {FC} from 'react'
import {Col, Input, Row} from 'antd'
import Form from 'antd/lib/form'
import FormEntityInterface from '../../../../common/models/form-entity-interface'
import {STANDARD_ITEM_RULES} from '../../../../../common/constants'
import IDS from '../../../constants/ids'
import PhoneItem from '../../../../../../common/components/form-items/phone-item'

const {Item} = Form

interface LegalEntityProps extends FormEntityInterface {}

const LegalEntity: FC<LegalEntityProps> = ({path = []}) => {
    return (
        <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'inn']} label={'ИНН'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'kpp']} label={'КПП'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
                <Item name={[...path, 'address']} label={'Юр. адрес'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'companyName']} label={'Полное наименование юр. лица'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'contactName']} label={'Контактное лицо (ФИО)'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <Item name={[...path, 'email']} label={'Электронная почта'} rules={STANDARD_ITEM_RULES}>
                    <Input/>
                </Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
                <PhoneItem name={[...path, IDS.CONTACT_PHONE]}/>
            </Col>
        </Row>
    )
}

export default LegalEntity